// /src/pages/admin/AdminLayout.tsx
import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import styles from "../../styles/AdminLayout.module.css";

export const AdminLayout = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/admin/login"); // SPA navigation
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <div className={styles.adminContainer}>
      {/* Header */}
      <header className={styles.adminHeader}>
        <h1>Admin Panel</h1>
        <button onClick={handleLogout} className={styles.logoutButton}>
          Logout
        </button>
      </header>

      {/* Sidebar Navigation */}
      <aside className={styles.sidebar}>
        <ul>
          <li>
            <NavLink
              to="/admin/projects"
              className={({ isActive }) => (isActive ? styles.active : "")}
            >
              Manage Projects
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/admin/artworks"
              className={({ isActive }) => (isActive ? styles.active : "")}
            >
              Manage Software Offrerings
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/admin/photos"
              className={({ isActive }) => (isActive ? styles.active : "")}
            >
              Manage Photo Gallery
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/admin/settings"
              className={({ isActive }) => (isActive ? styles.active : "")}
            >
              Edit Homepage Settings
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/admin/contacts"
              className={({ isActive }) => (isActive ? styles.active : "")}
            >
              View Contacts
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/admin/feedback"
              className={({ isActive }) => (isActive ? styles.active : "")}
            >
              View Feedback
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/admin/faqs"
              className={({ isActive }) => (isActive ? styles.active : "")}
            >
              Manage FAQs
            </NavLink>
          </li>
        </ul>
      </aside>

      {/* Main Content Area */}
      <main className={styles.content}>
        <Outlet />
      </main>
    </div>
  );
};
